import { render, staticRenderFns } from "./LegendItem.vue?vue&type=template&id=a4b9b2aa&scoped=true"
import script from "./LegendItem.vue?vue&type=script&lang=js"
export * from "./LegendItem.vue?vue&type=script&lang=js"
import style0 from "./LegendItem.vue?vue&type=style&index=0&id=a4b9b2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b9b2aa",
  null
  
)

export default component.exports